import React from "react";
import { useHistory } from "react-router-dom";
import Container from "../../components/Container";
import CTAButton from "../../components/CTAButton";

import * as S from "./styles";

const Error404 = () => {
  const history = useHistory();

  return (
    <Container type={"full"}>
      <S.Wrapper>
        <S.Title>Ops!</S.Title>
        <S.Text className="error-description">Página não encontrada.</S.Text>
        <CTAButton
          text="Volte a navegação"
          onClick={() => history.push("/explore")}
          id={"btn-error_404-volte_a_navegacao"}
          name={"btn-error_404-volte_a_navegacao"}
        />
      </S.Wrapper>
    </Container>
  );
};

export default Error404;
